

export const routesSearch = [
    {
        name: "Prospectos",
        path: "/admin/prospects"
    },
    {
        name: "Clientes",
        path: "/admin/clientes"
    },
]